/*
  Koala Pets — sticky cart button
  Opens the native Dawn cart drawer and mirrors the header cart count.
  Framework-free and defensive. (Cart upsell/discount were removed to keep the
  drawer simple and match Dawn's proven layout.)
*/
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setCount(sticky, countEl, n) {
    countEl.textContent = n;
    sticky.classList.toggle('is-empty', !n);
  }

  function updateStickyCount() {
    var sticky = document.querySelector('[data-koala-sticky-cart]');
    if (!sticky) return;
    var countEl = sticky.querySelector('[data-koala-sticky-count]');
    if (!countEl) return;

    // Prefer the header bubble (Dawn keeps it in sync); fall back to /cart.js
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) {
      var n = parseInt(bubble.textContent.trim(), 10);
      if (!isNaN(n)) { setCount(sticky, countEl, n); return; }
    }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(sticky, countEl, c.item_count); })
      .catch(function () {});
  }

  // Open the drawer (or fall back to the cart page)
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest('[data-koala-sticky-cart]');
    if (!sticky) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); }
    else { window.location.href = root + 'cart'; }
  });

  // Keep the count in sync with the header cart bubble
  function observeBubble() {
    var bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble || !window.MutationObserver) return;
    new MutationObserver(updateStickyCount).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState !== 'loading') { observeBubble(); updateStickyCount(); }
  else { document.addEventListener('DOMContentLoaded', function () { observeBubble(); updateStickyCount(); }); }
})();
